import { guideActions } from '../ActionTypes';
import { updateState } from '../../middlewares/utils';

const initialFormData = {
  Id: '0',
  Title: '',
  Description: '',
  DownloadURL: '',
  FeaturedImageURL: '',
  OrderNumber: '',
  SlugURL: ''
};

const defaultState = {
  guideList: [],
  tableLoading: false,
  form: initialFormData,
  formLoading: false,
  formError: null,
  deleteId: null
};


export default (state = defaultState, actions) => {
  switch (actions.type) {
    case guideActions.GUIDE_FETCH_START:
      return updateState(state, { tableLoading: true });
    case guideActions.GUIDE_FETCH_SUCCESS:
      return updateState(state, { tableLoading: false, guideList: actions.payload });
    case guideActions.GUIDE_FETCH_ERROR:
      return updateState(state, { tableLoading: false, ...actions.payload });
    case guideActions.GUIDE_SAVE_START:
      return updateState(state, { formLoading: true, formError: null, form: initialFormData });
    case guideActions.GUIDE_SAVE_SUCCESS:
      return updateState(state, { formLoading: false, form: initialFormData });
    case guideActions.GUIDE_SAVE_FAILED:
      return updateState(state, { formLoading: false, ...actions.payload });
    case guideActions.GUIDE_SET_FORM:
      return updateState(state, { ...actions.payload, formError: null });
    case guideActions.GUIDE_RESET_FORM:
      return updateState(state, { form: initialFormData });
    default:
      return state;
  }
};
